import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {MainComponent} from '@modules/main/main.component';
import {BlankComponent} from '@pages/blank/blank.component';
import {LoginComponent} from '@modules/login/login.component';
import {ProfileComponent} from '@pages/profile/profile.component';
import {RegisterComponent} from '@modules/register/register.component';
import {DashboardComponent} from '@pages/dashboard/dashboard.component';
import {AuthGuard} from '@guards/auth.guard';
import {NonAuthGuard} from '@guards/non-auth.guard';
import {ForgotPasswordComponent} from '@modules/forgot-password/forgot-password.component';
import {RecoverPasswordComponent} from '@modules/recover-password/recover-password.component';
import {PrivacyPolicyComponent} from '@modules/privacy-policy/privacy-policy.component';
import {MainMenuComponent} from '@pages/main-menu/main-menu.component';
import {SubMenuComponent} from '@pages/main-menu/sub-menu/sub-menu.component';
import { HomeComponent } from '@pages//home/home.component';
import { UserProfileComponent } from '@pages/user-profile/user-profile.component';
import { ListVehicleComponent } from '@pages/list-vehicle/list-vehicle.component';
import { AddVehicleComponent } from '@pages/add-vehicle/add-vehicle.component';
import { AddTrainingComponent } from '@pages/add-training/add-training.component';
import { NewProductComponent} from '@pages/new-product/new-product.component';
import { ProductVsParameterComponent } from '@pages/product-vs-parameter/product-vs-parameter.component';

import { ListTrainingComponent } from '@pages/list-training/list-training.component';
import { AddTestingComponent } from '@pages/add-testing/add-testing.component';
// import { Interceptor } from './service/interceptor';
import { FswDashboardComponent } from '@pages/fsw-dashboard/fsw-dashboard.component';

import { ListTestingComponent } from '@pages/list-testing/list-testing.component';
import { ViewSampleDetailComponent } from '@pages/view-sample-detail/view-sample-detail.component';
import { AddAwpComponent } from '@pages/add-awp/add-awp.component';
import { ListAwpComponent } from '@pages/list-awp/list-awp.component';
import { ViewDocComponent } from '@pages/view-doc/view-doc.component';
import { AddUserComponent } from '@pages/add-user/add-user.component';
import { EditUserComponent } from '@pages/edit-user/edit-user.component';
import { AdminDashboardComponent } from '@pages/admin-dashboard/admin-dashboard.component';
import { VerifyAccountComponent } from '@pages/verify-account/verify-account.component';
import { SoDashboardComponent } from './pages/so-dashboard/so-dashboard.component';
import { ListTrainingStatewiseComponent } from '@pages/list-training-statewise/list-training-statewise.component';
import { ListTestingStatewiseComponent } from '@pages/list-testing-statewise/list-testing-statewise.component';
import { ListVehicleStatewiseComponent } from '@pages/list-vehicle-statewise/list-vehicle-statewise.component';
import { ListAwpStatewiseComponent } from '@pages/list-awp-statewise/list-awp-statewise.component';
import { RegDashboardComponent } from './pages/reg-dashboard/reg-dashboard.component';
import { AddEquipmentsComponent } from '@pages/add-equipments/add-equipments.component';
import { AddManpowerComponent } from '@pages/add-manpower/add-manpower.component';
import { AddTestingcapabilityComponent } from '@pages/add-testingcapability/add-testingcapability.component';
import { UpdateFswStatusComponent } from '@pages/update-fsw-status/update-fsw-status.component';
import { LocationTestComponent } from '@components/location-test/location-test.component';
import { FswStatusComponent } from './pages/fsw-status/fsw-status.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component' 
import { ListVehicleHomeComponent } from '@pages/list-vehicle-home/list-vehicle-home.component';
import { ListVehicleStatewiseHomeComponent } from '@pages/list-vehicle-statewise-home/list-vehicle-statewise-home.component';
import { HomeHindiComponent } from '@pages/home-hindi/home-hindi.component';
// const routes: Routes = [
//     {
//         path: '',
//         component: MainComponent,
//         canActivate: [AuthGuard],
//         canActivateChild: [AuthGuard],
//         children: [
//             {
//                 path: 'profile',
//                 component: UserProfileComponent
//             },
//             {
//                 path: 'blank',
//                 component: BlankComponent
//             },
//             {
//                 path: 'sub-menu-1',
//                 component: SubMenuComponent
//             },
//             {
//                 path: 'sub-menu-2',
//                 component: BlankComponent
//             },
//             {
//                 path: '',
//                 component: DashboardComponent
//             },
//             {
//                 path: 'list-vehicle',
//                 component: ListVehicleComponent
//             },
//             {
//                 path: 'add-vehicle',
//                 component: AddVehicleComponent
//             }
//         ]
//     },
//     {
//         path: 'login',
//         component: LoginComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {
//         path: 'register',
//         component: RegisterComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {
//         path: 'forgot-password',
//         component: ForgotPasswordComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {
//         path: 'recover-password',
//         component: RecoverPasswordComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {
//         path: 'privacy-policy',
//         component: PrivacyPolicyComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {
//         path: 'home',
//         component: HomeComponent,
//         canActivate: [NonAuthGuard]
//     },
//     {path: '**', redirectTo: ''}
// ];
const routes: Routes = [
    { path: "", pathMatch: "full", redirectTo: "home" },
    { path: 'home', component: HomeComponent },
    { path: 'main', component: MainComponent },
    { path: 'about', component: AddTrainingComponent },
    { path: 'home/hi', component: HomeHindiComponent },

   
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'blank', component: BlankComponent,
         
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-training', component: AddTrainingComponent,
        //  canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-training', component: ListTrainingComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-testing', component: ListTestingComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        { path: 'add-testing', component: AddTestingComponent },
      ]
    },
  
    { path: 'login', component: LoginComponent },
  
    {
      path: '',
      component: MainComponent,
      children: [
        { path: 'fsw-dashboard', component: FswDashboardComponent },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        { path: 'admin-dashboard', component: AdminDashboardComponent },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        { path: 'it-dashboard', component: AdminDashboardComponent },
      ]
    },
  
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'view-sample/:sampleId', component: ViewSampleDetailComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
  
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-vehicle', component: AddVehicleComponent,
         // canActivate: [AuthGuard],
          data: {
            role: 'ADMIN'
          }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-vehicle', component: ListVehicleComponent,
         // canActivate: [AuthGuard],
          data: {
            role: 'ADMIN'
          }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-awp', component: AddAwpComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-awp', component: ListAwpComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'view-doc/:categ/:Id/:type', component: ViewDocComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'view-profile', component: UserProfileComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-user', component: AddUserComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'edit-user', component: EditUserComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      children: [
        {
          path: 'verify-account/:userId', component: VerifyAccountComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'profile', component: UserProfileComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'so-dashboard', component: SoDashboardComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-training-statewise', component: ListTrainingStatewiseComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-training/:stateCode', component: ListTrainingComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-testing-statewise', component: ListTestingStatewiseComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-vehicle-statewise', component: ListVehicleStatewiseComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
        
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-vehicle-statewise-home', component: ListVehicleStatewiseHomeComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-testing/:stateCode', component: ListTestingComponent,
        //  canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-vehicle/:stateCode', component: ListVehicleComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-vehicle-home/:stateCode', component: ListVehicleHomeComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-awp-statewise', component: ListAwpStatewiseComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'new-product', component: NewProductComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path:'productVsParameter', component:ProductVsParameterComponent,
          //canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'list-awp/:stateCode', component: ListAwpComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        { path: 'reg-dashboard', component: RegDashboardComponent },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-equipment/:userId', component: AddEquipmentsComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
        { path: 'location-test', component: LocationTestComponent },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-manpower/:userId', component: AddManpowerComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'add-testingCapability/:userId', component: AddTestingcapabilityComponent,
         // canActivate: [AuthGuard],
          // data: {
          //   role: 'USER'
          // }
        },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'update-fsw-status/:stateCode', component: UpdateFswStatusComponent,
         
        },
        { path: 'fsw-status', component: FswStatusComponent },
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        {
          path: 'edit-vehicle/:userId', component: AddVehicleComponent,
         // canActivate: [AuthGuard],
          data: {
            role: 'ADMIN'
          }
        }
      ]
    },
    {
      path: '',
      component: MainComponent,
      children: [
        
        {
          path: 'contact', component: ContactUsComponent,
        
         
        }
      ]
    }
    
  ];

@NgModule({
    imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
    exports: [RouterModule]
})
export class AppRoutingModule {}
